import { ResturantData } from "@/types/globalTypes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function SubscribtionExpireBadge() {
  const { t } = useTranslation();
  const ResturantData = useSelector(
    (state: { resturant: { resturantData: ResturantData } }) =>
      state.resturant.resturantData,
  );

  const WithoutPlan = ResturantData?.subscription === null
  
  const expireDate = ResturantData?.subscription?.expire
    ? new Date(ResturantData?.subscription?.expire * 1000)
    : null;

  const stringExpireDate = expireDate
    ? `${expireDate.getDate().toString().padStart(2, "0")}/${(expireDate.getMonth() + 1).toString().padStart(2, "0")}/${expireDate.getFullYear()}`
    : null;

  if (WithoutPlan || !expireDate) return null;

  return (
    <div
      className="mb-4 flex items-center rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-sm text-yellow-800 dark:border-yellow-800 dark:bg-gray-800 dark:text-yellow-300"
      role="alert"
    >
      <div>
        {t("subscribtionSettings.expireDate")}
        <span className="font-medium"></span>{" "}
        {t("subscribtionSettings.expireText", {
          date: stringExpireDate,
        })}
      </div>
    </div>
  );
}

export default SubscribtionExpireBadge;
